document.querySelector(".forgot-trigger").onclick = function (event) {
  event.preventDefault()
  document.querySelector("#forgot").classList.add("active")
  document.querySelector("#login").classList.remove("active")
}

document.querySelector(".login-trigger").onclick = function (event) {
  event.preventDefault()
  document.querySelector("#login").classList.add("active")
  document.querySelector("#forgot").classList.remove("active")
}

if (window.location.hash) {
  if (window.location.hash.indexOf("recover") == 1) {
    document.querySelector("#forgot").classList.add("active")
    document.querySelector("#login").classList.remove("active")
  } else {
    document.querySelector("#forgot").classList.remove("active")
    document.querySelector("#login").classList.add("active")
  }
}
